import { useRef } from 'react'
import { messages, ProrithmSocketMessage } from './Constants'
import { generateRandomID, safelyParse } from './utils'

const useProrithmSocket = () => {
  const socketRef = useRef<WebSocket | null>(null)
  const deviceId = generateRandomID(6)

  const createProrithmWebsocket = () => {
    const socket = new WebSocket(
      `${process.env.REACT_APP_PRORITHM_SOCKET_URL}${deviceId}`
    )

    socketRef.current = socket

    socket.onopen = function (event) {
      console.log(messages?.websocketConnection, event.type)
    }

    socket.onmessage = (event) => {
      const message = safelyParse(event.data)
      if (!message) return
    }

    socket.onerror = (event) => {
      console.error(messages?.websocketError, event)
    }

    socket.onclose = function (event) {
      console.log(messages?.websocketClosed, event?.code)

      // Normal closure codes
      const normalCodes = [1000, 1001]

      if (!normalCodes.includes(event?.code)) {
        console.log(messages?.websocketClosedAbnormally)

        // Close existing socket if it's not already closed
        if (socketRef?.current?.readyState !== WebSocket.OPEN) {
          try {
            socketRef?.current?.close()
          } catch (e) {
            console.warn(messages?.websocketCloseError, e)
          }
          createProrithmWebsocket()
        }
      }
    }
  }

  const sendMessageOnSocket = (payload: ProrithmSocketMessage) => {
    if (socketRef?.current?.readyState === WebSocket.OPEN) {
      socketRef?.current?.send(JSON.stringify(payload))
    } else {
      console.warn(messages?.websocketNotOpen, payload)
    }
  }

  const closeProrithmWebSocket = () => {
    if (socketRef?.current) {
      socketRef?.current?.close()
      console.log(messages?.websocketConnectionClosed)
    }
  }

  return {
    createProrithmWebsocket,
    sendMessageOnSocket,
    closeProrithmWebSocket,
  }
}

export default useProrithmSocket
